// extracted by mini-css-extract-plugin
module.exports = {"miniCartPopup":"az_NZ","customPaperDrawer":"az_OZ","miniCartFlyoutDialog":"az_PZ"};